export default "__VITE_ASSET__97378cf9__"